import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import { formSelectors } from '@/redux/slices/formSlice'
import { useAppSelector } from '@/redux/store'
import { Stack, useNavigation, type Href, type NativeStackHeaderItem, type NativeStackNavigationOptions } from 'expo-router'
import Head from 'expo-router/head'
import { useEffect, useMemo } from 'react'
import { Platform } from 'react-native'

type Props = {
  formToken: string
  hideTitle?: boolean
  headerTransparent: boolean
  headerStyle?: NativeStackNavigationOptions['headerStyle']
  titlePrefix?: string
  defaultBackHref?: Href
  headerRightItems?: () => NativeStackHeaderItem[]
  headerButtonClassName?: string
}

export default function FormStackScreen({
  formToken,
  hideTitle = false,
  titlePrefix,
  headerTransparent,
  headerStyle,
  defaultBackHref,
  headerRightItems,
  headerButtonClassName,
}: Props) {
  const navigation = useNavigation()
  const headerLeftItems = useWebBackButton(defaultBackHref)

  const formName = useAppSelector(state => formSelectors.selectById(state.forms, formToken)?.displayName)
  const title = useMemo(() => [titlePrefix, formName].filter(Boolean).join(' - '), [formName, titlePrefix])

  useEffect(() => {
    navigation.setOptions({
      title: hideTitle ? '' : title,
      ...buildScreenHeaderItems({ left: headerLeftItems, right: headerRightItems?.(), buttonClassName: headerButtonClassName }),
    })
  }, [navigation, title, headerRightItems, hideTitle, headerLeftItems, headerButtonClassName])

  return (
    <>
      {Platform.OS === 'web' && (
        <Head>
          <title>{title}</title>
        </Head>
      )}
      <Stack.Screen options={{ headerTransparent, ...(headerStyle ? { headerStyle } : {}) }} />
    </>
  )
}
